export default __webpack_public_path__ + "static/media/timer-machine-icon.7b02d176.png";